<div class="days-container">
    <div class="day-item" [class.selected]="value.includes(day.id)" *ngFor="let day of weekDayOptions" (click)="onModelChange(day.id)">
        {{day.name}}
    </div>
</div>
